"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BuildingHouse = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _Icon = require("../Icon");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const BuildingHouseSvg = () => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 24 25",
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.183 2.249h-5.736L4.745 8.59H6.63v3.659h1.462V8.59h3.412v3.659h1.462v-4.39h-.039l3.035-3.797 3.456 3.309h-.116v9.512h-2.194v1.464h3.656V8.659l.225.216L22 7.818zm-5.085 1.463h3.27L11.64 7.127H8.028z",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "currentColor",
    d: "M14.038 8.005v1.463H15.5V8.005zM14.038 12.737v-1.464H15.5v1.464zM16.524 8.005v1.463h1.462V8.005zM16.524 12.737v-1.464h1.462v1.464zM17.986 14.2h-1.462v1.464h1.462z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.481 13.469h6.528l4.113 4.116-1.034 1.035-.382-.382v4.011H3.664v-3.902H2zm-.355 4.878v2.439h3.33l.008-2.44zm4.804-.948-.011 3.387h1.056V18.59h1.462v2.196h.807v-4.011l-1.497-1.499zm.186-2.467H6.234L4.84 16.883h3.604z",
    clipRule: "evenodd"
  })]
});
const BuildingHouse = props => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, _objectSpread(_objectSpread({}, props), {}, {
  component: BuildingHouseSvg
}));
exports.BuildingHouse = BuildingHouse;